import * as THREE from 'three';
import { choosePreferredAnimatedCamera } from '../../utils/animations';

export interface CameraBinding {
  camera: THREE.Camera | null;
  hasAnimatedCamera: boolean;
}

export function bindSceneCamera(
  cameras: THREE.Camera[],
  animations: THREE.AnimationClip[],
): CameraBinding {
  const camera = choosePreferredAnimatedCamera(cameras, animations);

  return {
    camera,
    hasAnimatedCamera: camera !== null,
  };
}

export function getBakedCamera(
  binding: CameraBinding | null | undefined,
): THREE.Camera | null {
  return binding?.camera ?? null;
}
